<template>
  <a
    class="title_tip"
    :class="{'en-title-tip': getLang() === 'en'}"
    href="https://help.westartrack.com/faq/d_5da9770d4db67f2b542982bc.html"
    target="_blank"
  >
    <i class="iconfont iconicon-test68" />
    {{ $t('message["1247"]') }}
  </a>
</template>

<script type="text/ecmascript-6">
import { getLang } from '@/lib/storage'
export default {
  methods: {
    getLang
  }
}
</script>

<style scoped lang="scss">
.title_tip {
  position: absolute;
  right: 0;
  top: 24px;
  background: #f0f8ff;
  box-sizing: border-box;
  width: 174px;
  height: 40px;
  margin: 0 12px 0 0;
  border-radius: 4px;
  color: #333;
  border: 1px solid #4ca0f2;
  line-height: 40px;
  .iconfont {
    color: #4ca0f2;
    vertical-align: middle;
    margin: 0 4px 0 12px;
    font-size: 16px;
  }
}
.title_tip:hover {
  cursor: pointer;
}
.en-title-tip {
  width: 240px !important;
}
// .more {
//   line-height: 24px;
//   padding: 8px 0 0 0;
// }
// .more:hover {
//   cursor: pointer;
// }
// .tip_content-ul, .more {
//   color: #5077aa;
//   li:first-child {
//     padding-top: 0
//   }
//   li{
//     line-height: 24px;
//     padding: 8px 0 0 0;
//   }
//   li:hover {
//     cursor: pointer;
//   }
// }
</style>
